import React from 'react'

const AboutUs = () => {
  document.title = 'เกี่ยวกับเรา | Run24Hrs'
  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: 10 }}>
        <h1>เกี่ยวกับเรา</h1>
      </div>
      <div style={{ textAlign: 'center' }}>
        <img
          className="about-us-img"
          style={{ marginBottom: 10 }}
          src="https://api.run24hrs.com/media/images/84704009_178554153460120_4594376990986862592_n.png"
        />
      </div>
      <p>
        Run24Hrs ก่อตั้งมาเพื่อส่งเสริมให้คนไทยออกกำลังกาย
        ร่วมกันเดิน-วิ่งเพื่อสุขภาพอย่างมีจุดมุ่งหมาย
        โดยสามารถเดิน-วิ่งอยู่ในสถานที่ใกล้บ้าน
        เเละรวบรวมผลการวิ่งมาส่งเพื่อรับของที่ระลึก
        โดยไม่ต้องเดินทางไปตามงานวิ่งต่างๆ นอกจากนี้ยังมีกลุ่มให้สมาชิกได้พูดคุย
        เเลกเปลี่ยนความคิดเห็นกัน
        เพื่อส่งเสริมเเละกระตุ้นจิตใจให้ถึงเป้าหมายต่างๆไปด้วยกัน เเละทาง
        Run24Hrs ยังเป็นกระบอกเสียงเล็กๆ ร่วมบริจาค
        ช่วยเหลือคนไทยตามโครงการต่างๆดังนี้
      </p>
      <p>ปี 2561</p>
      <ul>
        <li>
          Run24Hrs และตัวเเทน ได้นำรายได้ส่วนนึงจากงานวิ่งตรุษจีน Happy Wealthy
          Run 2019 ไปซื้ออุปกรณ์กีฬา อุปกรณ์การเรียน ขนม และนม
          ให้กับน้องๆที่โรงเรียน บ้านองสิต จังหวัดกาญจนบุรี เป็นจำนวนเงินประมาณ​
          15,000 บาท
        </li>
        <li>
          โครงการกระตุกหัวใจ ทีม Run24hrs อยู่อับดับที่ 5 และมีระยะวิ่งสะสมรวม
          72,894 km ซึ่งทาง Run24Hrs บริจาค 1 km = 1 บาท
          ยอดบริจาคของนักวิ่งทุกท่านจะอยู่ที่ 72,894 บาท Run24Hrs
          ร่วมสบทบเพิ่มให้อีก 7,106 บาท รวมเป็นเงินทั้งสิ้น "80,000 บาท"
          สามารถบริจาคเป็นเครื่อง AED 1 เครื่อง ราคาเครื่องละ 80,000 บาท
          (รวมค่าติดตั้งและบำรุงรักษา)
        </li>
        <li>
          ไตรมาสที่ 1 (มกราคม-มีนาคม) ของงาน Zodiac Challenge 2019 - Run24Hrs
          ได้นำเงินบริจาคให้ มูลนิธิ โรงพยาบาลเด็ก วัตถุประสงค์เพื่อโครงการ
          ต่อลมหายใจให้โอกาสชีวิต เพื่อจัดซื้อเครื่องช่วยหายใจให้น้อง
          เป็นจำนวนเงิน 286,000 บาท
        </li>
        <li>
          ไตรมาสที่ 2 (เมษายน-มิถุนายน) ของงาน Zodiac Challenge 2019 - Run24Hrs
          นำเงินไปร่วมบริจาคให้กับ "กองทุนภูมิคุ้มกันบำบัดมะเร็งจุฬา"
          สำหรับวิจัยยารักษามะเร็งเพื่อทำให้แพทย์ไทยสามารถผลิตยารักษามะเร็งได้สำเร็จและทำให้มีราคาถูกที่ทุกคนสามารถเอื้อมถึงและได้รับการรักษาโรคมะเร็ง
          เป็นจำนวนเงิน 321,975 บาท
        </li>
        <li>
          ไตรมาสที่ 3 (กรกฎาคม-กันยายน) ของงาน Zodiac Challenge 2019 - Run24Hrs
          นำเงินไปร่วมบริจาคให้กับ "มูลนิธิเพื่อสนับสนุนการผ่าตัดหัวใจเด็ก
          โรงพยาบาลราชวิถี"
          เพื่อช่วยเหลือเด็กที่เป็นโรคหัวใจพิการแต่กำเนิดให้ได้รับการรักษาอย่างทันท่วงที
          เพื่อป้องกันการเกิดภาวะแทรกซ้อนและการเสียชีวิตก่อนเวลาอันควร
          เป็นจำนวนเงิน 340,463.02 บาท
        </li>
        <li>
          ไตรมาสที่ 4 (ตุลาคม - ธันวาคม) ของงาน Zodiac Challenge 2019 - Run24Hrs
          ได้นำเงินไปร่วมบริจาคให้กับ "โรงพยาบาลถ้ำพรรณรา จังหวัดนครศรีธรรมราช"
          เพื่อจัดซื้ออุปกรณ์ทางการแพทย์ที่ขาดแคลน
          รวมไปถึงซ่อมอุปกรณ์ทางการแพทย์ที่ชำรุดเสียหาย เป็นจำนวนเงิน 325,000
          บาท
        </li>
        <li>
          งานวิ่ง Dog vs Cat - ทีมน้องหมาบริจาคให้มูลนิธิเพื่อสุนัขในซอย =
          36,000 บาท ทีมน้องเเมวบริจาคให้ PAWS Bangkok = 31,000 บาท
          รวมเป็นยอดเงินทั้งหมด 67,000 บาท
        </li>
        <li>
          งานวิ่งฟรี Save The Ocean เเละ Save The Elephant & Forest!
          บริจาคเงินช่วยเหลือพี่น้องชาวอุบลฯ และอีสานจากภัยจากน้ำท่วม
          เป็นจำนวนเงิน 50,000 บาท
        </li>
      </ul>
      <p>สรุปยอดรวมในการบริจาคทั้งหมด ของปี 2019 เป็นเงิน 1,485,438.02 บาท</p>
      <p>
        ทีมงาน <a href="https://run24hrs.com">#Run24Hrs</a>{' '}
        ขอขอบคุณนักวิ่งทุกคนที่ร่วมกิจกรรมกับเรามาก ๆ ค่ะ
      </p>
    </div>
  )
}

export default AboutUs



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/AboutUs/index.js